import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createBairunSvcBalanceSub, deleteBairunSvcBalanceSubByIds, updateBairunSvcBalanceSub, findBairunSvcBalanceSub, getBairunSvcBalanceSubList, updateBairunSvcBalanceSubStatus } from '@/api/bairun/svcBalanceSub';
import { findBairunSvcBalanceByNumber } from '@/api/bairun/svcBalance';
import { getStationBaseInfoList } from '@/api/bairun/stationBaseInfo';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import SearchTerm from '@/components/searchTerm';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'BairunSvcBalanceSub',
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    getStationName: function getStationName(id) {
      for (var i = 0; i < _this.stationOptions.length; i++) {
        if (_this.stationOptions[i].ID === id) {
          return _this.stationOptions[i].stationName;
        }
      }

      return '';
    },
    getOilCodeNames: function getOilCodeNames(oilCodes) {
      var oilCodeArr = oilCodes.split(',');
      var oilCodeNames = '';

      if (oilCodeArr.includes('-1')) {
        return '全部油品支持';
      }

      _this.oilCodesOptions.map(function (oil) {
        if (oilCodeArr.includes(oil.value + '')) {
          oilCodeNames += oil.label + ',';
        }
      });

      return oilCodeNames.substr(0, oilCodeNames.length - 1);
    }
  },
  mixins: [infoList],
  components: {
    SearchTerm: SearchTerm
  },
  data: function data() {
    return {
      listApi: getBairunSvcBalanceSubList,
      loading: false,
      searchInfo: {
        // 按配置顺序显示
        'svcNumber': '',
        'subSvcNumber': '',
        'mobile': '',
        'activeStationId': '',
        'fullName': '',
        'svcStatus': ''
      },
      addAndUpdateVisible: false,
      addAndUpdateTitle: '',
      viewVisible: false,
      loseOrCancelVisible: false,
      type: '',
      multipleSelection: [],
      svcStatusOptions: [],
      oilCodesOptions: [],
      isPasswordOptions: [],
      stationOptions: [],
      rebairunSvcBalance: {},
      formData: {},
      rules: {
        svcNumber: [{
          required: true,
          message: '请输入主卡卡号',
          trigger: 'blur'
        }],
        subSvcNumber: [{
          required: true,
          message: '请输入副卡卡号',
          trigger: 'blur'
        }],
        mobile: [{
          required: true,
          message: '请输入手机号',
          trigger: 'blur'
        }],
        activeStationId: [{
          required: true,
          message: '请选择发卡油站',
          trigger: 'blur'
        }]
      },
      loseRules: {
        optDescribe: [{
          required: true,
          message: '请输入挂失原因',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('stations', ['allStationMap', 'allStations'])), {}, {
    getRule: function getRule() {
      switch (this.type) {
        case 'create':
          return this.rules;

        case 'update':
          return this.rules;

        case 'lose':
          return this.loseRules;

        case 'unlose':
          return this.loseRules;

        default:
          break;
      }
    }
  }),
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {// 使用keepalive的页面,重新展示都会调用

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // 使用keepalive的页面,重新展示不会调用
              console.log('created');

              _this2.init();

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    init: function init() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var stationOptions;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.formData = _this3.initData();
                _context3.next = 3;
                return _this3.getDict('svcStatus');

              case 3:
                _this3.svcStatusOptions = _context3.sent;
                _context3.next = 6;
                return _this3.getDict('isSvcPassword');

              case 6:
                _this3.isPasswordOptions = _context3.sent;
                _context3.next = 9;
                return _this3.getDict('oilCode');

              case 9:
                _this3.oilCodesOptions = _context3.sent;
                _context3.next = 12;
                return getStationBaseInfoList({
                  page: 1,
                  pageSize: 999999,
                  donNotShowLoading: true
                });

              case 12:
                stationOptions = _context3.sent;
                _this3.stationOptions = stationOptions.data.list;

                if (_this3.$route.params.type === 'create') {
                  _this3.formData.svcNumber = _this3.$route.params.svcNumber;

                  _this3.onAdd();
                }

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    initData: function initData() {
      var formdata = {
        svcNumber: '',
        subSvcNumber: '',
        activeDate: new Date(),
        activeStationId: '',
        svcStatus: 1,
        address: '',
        fullName: '',
        idCard: '',
        mobile: '',
        uid: '',
        limitDayBalance: 99999999,
        limitOrderBalance: 99999999,
        consumeSum: 0,
        isPassword: 1,
        remark: '',
        optStationId: 0,
        optType: 0,
        optDescribe: ''
      };
      return Object.assign(formdata, this.initLoseData());
    },
    initLoseData: function initLoseData() {
      return {};
    },
    onSearch: function onSearch() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this4.page = 1;
                _this4.pageSize = 10;
                _this4.loading = true;
                _context4.next = 5;
                return _this4.getTableData();

              case 5:
                _this4.loading = false;

              case 6:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onClose: function onClose() {
      this.addAndUpdateVisible = false;
      this.viewVisible = false;
      this.loseOrCancelVisible = false;
      this.formData = this.initData();
    },
    onView: function onView(row) {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return findBairunSvcBalanceSub({
                  ID: row.ID
                });

              case 2:
                res = _context5.sent;

                if (res.code === 0) {
                  _this5.formData = res.data.rebairunSvcBalanceSub;
                  _this5.type = 'view';
                  _this5.viewVisible = true;
                }

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    onUpdate: function onUpdate(row) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this6;
                _context6.next = 3;
                return findBairunSvcBalanceSub({
                  ID: row.ID
                });

              case 3:
                res = _context6.sent;
                that.type = 'update';

                if (res.code === 0) {
                  that.formData = res.data.rebairunSvcBalanceSub;
                  that.addAndUpdateVisible = true;
                  that.addAndUpdateTitle = '变更操作';
                }

              case 6:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    onLose: function onLose() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var res, formData;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(_this7.multipleSelection.length === 0)) {
                  _context7.next = 3;
                  break;
                }

                _this7.$message({
                  type: 'warning',
                  message: '请选择要操作的数据'
                });

                return _context7.abrupt("return");

              case 3:
                _context7.next = 5;
                return findBairunSvcBalanceSub({
                  ID: _this7.multipleSelection[0].ID
                });

              case 5:
                res = _context7.sent;
                _this7.type = 'lose';

                if (res.code === 0) {
                  formData = res.data.rebairunSvcBalanceSub;
                  _this7.formData = Object.assign(formData, _this7.initLoseData());
                  _this7.loseOrCancelVisible = true;
                }

              case 8:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    onUnLose: function onUnLose() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var res, formData;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(_this8.multipleSelection.length === 0)) {
                  _context8.next = 3;
                  break;
                }

                _this8.$message({
                  type: 'warning',
                  message: '请选择要操作的数据'
                });

                return _context8.abrupt("return");

              case 3:
                _context8.next = 5;
                return findBairunSvcBalanceSub({
                  ID: _this8.multipleSelection[0].ID
                });

              case 5:
                res = _context8.sent;
                _this8.type = 'unlose';

                if (res.code === 0) {
                  formData = res.data.rebairunSvcBalanceSub;
                  _this8.formData = Object.assign(formData, _this8.initLoseData());
                  _this8.loseOrCancelVisible = true;
                }

              case 8:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }))();
    },
    onAble: function onAble(row) {
      if (row.svcStatus == 1) {
        this.$message({
          type: 'success',
          message: '已开启'
        });
        return;
      }

      this.formData.optType = 12;
      this.formData.optDescribe = '启用';
      this.handleStatus(row.ID, 1);
    },
    onUnAble: function onUnAble(row) {
      if (row.svcStatus == 2) {
        this.$message({
          type: 'success',
          message: '已禁用'
        });
        return;
      }

      this.formData.optType = 13;
      this.formData.optDescribe = '禁用';
      this.handleStatus(row.ID, 2);
    },
    handleStatus: function handleStatus(ID, svcStatus) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var res;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return updateBairunSvcBalanceSubStatus({
                  'ID': ID,
                  'svcStatus': svcStatus,
                  'optType': _this9.formData.optType,
                  'optDescribe': _this9.formData.optDescribe
                });

              case 2:
                res = _context9.sent;

                _this9.enterDialogRepose(res);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    handleFindBairunSvcBalance: function handleFindBairunSvcBalance(svcNumber, fn) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var that, res;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                that = _this10;
                _context10.next = 3;
                return findBairunSvcBalanceByNumber({
                  svcNumber: svcNumber
                });

              case 3:
                res = _context10.sent;

                if (res.code === 0 && res.data.rebairunSvcBalance) {
                  that.rebairunSvcBalance = res.data.rebairunSvcBalance;
                } else {
                  that.rebairunSvcBalance = {};
                  that.$message({
                    showClose: true,
                    type: 'error',
                    message: '主卡卡号不存在'
                  });
                }

                if (fn) {
                  fn();
                }

              case 6:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    onDialogSubmit: function onDialogSubmit() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var that;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                that = _this11;
                _context11.t0 = _this11.type;
                _context11.next = _context11.t0 === 'create' ? 4 : _context11.t0 === 'update' ? 14 : _context11.t0 === 'lose' ? 16 : _context11.t0 === 'unlose' ? 19 : 22;
                break;

              case 4:
                if (!(JSON.stringify(that.rebairunSvcBalance) === '{}')) {
                  _context11.next = 10;
                  break;
                }

                _context11.next = 7;
                return that.handleFindBairunSvcBalance(that.formData.svcNumber);

              case 7:
                if (!(JSON.stringify(that.rebairunSvcBalance) === '{}')) {
                  _context11.next = 10;
                  break;
                }

                _this11.$message({
                  showClose: true,
                  type: 'error',
                  message: '主卡卡号不存在'
                });

                return _context11.abrupt("return");

              case 10:
                that.formData.optType = 7;
                that.formData.optDescribe = that.formData.remark;
                that.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    createBairunSvcBalanceSub(that.formData).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context11.abrupt("break", 23);

              case 14:
                that.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    updateBairunSvcBalanceSub(that.formData).then(function (res) {
                      that.enterDialogRepose(res);
                    });
                  } else {
                    return false;
                  }
                });
                return _context11.abrupt("break", 23);

              case 16:
                that.formData.optType = 10;
                that.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    that.handleStatus(that.formData.ID, 3);
                  } else {
                    return false;
                  }
                });
                return _context11.abrupt("break", 23);

              case 19:
                that.formData.optType = 11;
                that.$refs['formData'].validate(function (valid) {
                  if (valid) {
                    that.handleStatus(that.formData.ID, 1);
                  } else {
                    return false;
                  }
                });
                return _context11.abrupt("break", 23);

              case 22:
                return _context11.abrupt("break", 23);

              case 23:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    enterDialogRepose: function enterDialogRepose(res) {
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '操作成功'
        });
        this.onClose();
        this.getTableData();
      }
    },
    handleSelChange: function handleSelChange(val) {
      this.multipleSelection = val;
    },
    handleDeletes: function handleDeletes() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var ids, res;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                ids = [];
                _this12.multipleSelection && _this12.multipleSelection.map(function (item) {
                  ids.push(item.ID);
                });
                _context12.next = 4;
                return deleteBairunSvcBalanceSubByIds({
                  ids: ids,
                  'optType': _this12.formData.optType,
                  'optDescribe': _this12.formData.optDescribe
                });

              case 4:
                res = _context12.sent;

                if (res.code === 0) {
                  _this12.$message({
                    type: 'success',
                    message: '删除成功'
                  });

                  if (_this12.tableData.length === ids.length && _this12.page > 1) {
                    _this12.page--;
                  }

                  _this12.getTableData();
                }

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }))();
    }
  }
};